import React, { Suspense } from "react";
import { Box } from "@material-ui/core";
import { StyledBackdrop } from "components/BackdropProvider/Backdrop.styled";
import { CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router";
import { getAuthState, getTokensMatSpecId } from "store/features/authorization/authorization.selectors";
import { Alert, Backdrop, AdminPanel } from "components";
import { PageNotFound } from "pages";
import { routes } from "pages/routes";
import { AppContainer } from "pages/App.styled";
import { TopPanel } from "components/TopPanel/TopPanel";
import { Unauthorized } from "./Unauthorized/Unauthorized";
import { useAdminPanel } from "components/AdminPanel/hooks";
import { matchPath, useLocation } from "react-router-dom";
import { isIFrame } from "utils";

export const App: React.FC = () => {
    const isVisible = useAdminPanel();
    const auth = useSelector(getAuthState);
    const matSpecId = useSelector(getTokensMatSpecId);
    //TODO: REMOVE WHEN BRIEFING FORM WILL BE MERGED
    const location = useLocation();
    const currentRoute = routes.find((route) => matchPath(location.pathname, route));

    return (
        <Box display="flex">
            {auth.isAuthorized && !auth.isAuthorizing && (
                <Suspense fallback="loading">
                    {matSpecId && matSpecId > 0 && <TopPanel matSpecId={matSpecId} />}
                    <AdminPanel />
                    {/*TODO: REMOVE WHEN BRIEFING FORM WILL BE MERGED*/}
                    <AppContainer
                        maxWidth={false}
                        disableMargin={isIFrame || isVisible || currentRoute?.key === "briefingForm"}>
                        <Alert />
                        <Backdrop />
                        <Switch>
                            {routes.map(({ key, ...route }) => {
                                return <Route key={key} {...route} />;
                            })}
                            <Route path="*" component={PageNotFound} />
                        </Switch>
                    </AppContainer>
                </Suspense>
            )}
            {!auth.isAuthorized && auth.isAuthorizing && (
                <StyledBackdrop open={true}>
                    <CircularProgress color="inherit" />
                </StyledBackdrop>
            )}

            {!auth.isAuthorized && !auth.isAuthorizing && <Unauthorized />}
        </Box>
    );
};
